import { Vector3 } from "three";
import { rad } from "./util/math";

export const SCURVE = [
    {

        position: {
            // start point
            x: 0,
            y: 0,
            z: 10.5,
        },

        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: rad(0)
        },

        length: 10,

        radius: 10,
        arc: rad(50),

        goal: 2

    },
    {

        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: rad(0)
        },

        length: 20
    },
    {
        orientation: [
            {
                global: true,
                vector: new Vector3(0, 0, 1),
                angle: rad(-15)
            },
            {
                vector: new Vector3(0, 1, 0),
                angle: rad(15)
            }
        ]
    },
    {
        orientation: [
            {
                global: true,
                vector: new Vector3(0, 0, 1),
                angle: rad(15)
            },
            {
                vector: new Vector3(0, 1, 0),
                angle: rad(-15)
            }
        ],

    },
    {
        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: 0
        },

        length: 50,

        radius: 10,
    },
    {

        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: rad(0)
        },

        length: 20,

        radius: 10,

    },
    {

        orientation: {
            global: true,
            vector: new Vector3(1,0,0),
            angle: rad(10)
        },

        length: 40
    },
    {

        orientation: {
            global: true,
            vector: new Vector3(1,0,0),
            angle: rad(-10)
        },

        length: 20
    },
    {
        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: 0
        },

        length: 50,

        radius: 10,

        goal: -1
    }
];

export const HILL = [
    {

        position: {
            // start point
            x: 0,
            y: 0,
            z: 10.01,
        },

        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: rad(0)
        },

        length: 20,

        radius: 10,
        arc: rad(30),

        goal: 12

    },
    {

        orientation: {
            global: true,
            vector: new Vector3(1,0,0),
            angle: rad(10)
        },

        length: 40
    },
    {

        orientation: {
            global: true,
            vector: new Vector3(1,0,0),
            angle: rad(-10)
        },

        length: 40
    },
    {
        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: 0
        },

        length: 100,

        radius: 10,
        arc: rad(30),

        goal: 7
    }
];


export default [
    {
        position: {
            // start point
            x: 0,
            y: -2,
            z: 10.01,
        },

        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: 0
        },

        length: 70,

        radius: 10,
        arc: rad(30),

        goal: 2
    },
    {
        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: rad(10)
        },

        length: 30,

        radius: 10,
        arc: rad(30)
    },
    {
        orientation: {
            global: true,
            vector: new Vector3(0, 1, 0),
            angle: 0
        },

        length: 100,

        radius: 10,
        arc: rad(30),

        goal: 7
    },
];



// WEBPACK FOOTER //
// ./src/track-data.js